import {
  bookingDatesMaybe,
  getTransactionTypeData,
} from 'containers/CheckoutPage/CheckoutPageTransactionHelpers';
import { getCancellationPolicy } from '../../transaction-update/utils/listings';

const capitalizeString = (s) => `${s.charAt(0).toUpperCase()}${s.substr(1)}`;

const prefixPriceVariantProperties = (priceVariant) => {
  if (!priceVariant) {
    return {};
  }

  const entries = Object.entries(priceVariant).map(([key, value]) => {
    return [`priceVariant${capitalizeString(key)}`, value];
  });
  return Object.fromEntries(entries);
};

const getOrderParams = (
  pageData,
  shippingDetails,
  optionalPaymentParams,
  config,
  otherParams = {}
) => {
  const quantity = pageData.orderData?.quantity;
  const quantityMaybe = quantity ? { quantity } : {};
  const seats = pageData.orderData?.seats;
  const seatsMaybe = seats ? { seats } : {};
  const deliveryMethod = pageData.orderData?.deliveryMethod;
  const deliveryMethodMaybe = deliveryMethod ? { deliveryMethod } : {};
  // price variant data for fixed duration bookings
  const priceVariant = pageData.orderData?.priceVariant;
  const priceVariantMaybe = priceVariant ? prefixPriceVariantProperties(priceVariant) : {};

  const { listingType, unitType } = pageData?.listing?.attributes?.publicData || {};
  const {
    adultSeats,
    childSeats,
    siblingSeats,
    ticketOption,
    customTicketSeats,
    sessions: pageDataSessions,
    blocks: pageDataBlocks,
  } = pageData?.orderData || {};

  const protectedDataMaybe = {
    protectedData: {
      cancellationPolicy: getCancellationPolicy({
        listing: pageData?.listing,
        type: ticketOption,
      }),
      ...getTransactionTypeData(listingType, unitType, config),
      ...deliveryMethodMaybe,
      ...shippingDetails,
      ...priceVariantMaybe,
      ...otherParams,
    },
  };

  // Note: Avoid misinterpreting the following logic as allowing arbitrary mixing of `quantity` and `seats`.
  // You can only pass either quantity OR seats and units to the orderParams object
  // Quantity represents the total booked units for the line item (e.g. days, hours).
  // When quantity is not passed, we pass seats and units.
  // If `bookingDatesMaybe` is provided, it determines `units`, and `seats` defaults to 1
  // (implying quantity = units)

  // These are the order parameters for the first payment-related transition
  // which is either initiate-transition or initiate-transition-after-enquiry
  const orderParams = {
    listingId: pageData?.listing?.id,
    ...deliveryMethodMaybe,
    ...quantityMaybe,
    ...seatsMaybe,
    ...bookingDatesMaybe(pageData.orderData?.bookingDates),
    ...protectedDataMaybe,
    ...optionalPaymentParams,
    adultSeats,
    childSeats,
    siblingSeats,
    ticketOption,
    sessions: otherParams.sessions ?? pageDataSessions,
    blocks: otherParams.blocks ?? pageDataBlocks,
    customTicketSeats,
    attendees: otherParams.attendees,
  };

  return orderParams;
};

export default getOrderParams;
